'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';
interface PolicyInfoFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  provisionCodes: string[];
  onToggleProvision: (code: string) => void;
  onReset: () => void;
}
export function PolicyInfoFilter(t0) {
  const $ = _c(26);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    provisionCodes,
    onToggleProvision,
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/query/policies/codes/provision"](),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isProvisionLoading
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const provisionOptions = t3;
  let t4;
  if ($[3] !== isProvisionLoading || $[4] !== onToggleProvision || $[5] !== provisionCodes || $[6] !== provisionOptions) {
    t4 = <FilterSection title={"\uC9C0\uC6D0\uD615\uD0DC"}><FilterCheckboxList options={provisionOptions} selectedValues={provisionCodes} onToggle={onToggleProvision} isLoading={isProvisionLoading} skeletonCount={6} /></FilterSection>;
    $[3] = isProvisionLoading;
    $[4] = onToggleProvision;
    $[5] = provisionCodes;
    $[6] = provisionOptions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onReset || $[9] !== t4) {
    t5 = <FilterSidebarShell onReset={onReset}>{t4}</FilterSidebarShell>;
    $[8] = onReset;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h3 className="font-700 text-Gray-900 typo-body4">지원형태</h3>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isProvisionLoading || $[13] !== onToggleProvision || $[14] !== provisionCodes || $[15] !== provisionOptions) {
    t7 = <div className="flex flex-col gap-12">{t6}<FilterChipGroup options={provisionOptions} selectedValues={provisionCodes} onToggle={onToggleProvision} isLoading={isProvisionLoading} skeletonCount={6} /></div>;
    $[12] = isProvisionLoading;
    $[13] = onToggleProvision;
    $[14] = provisionCodes;
    $[15] = provisionOptions;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isDrawerOpen || $[18] !== onApplyDrawer || $[19] !== onCloseDrawer || $[20] !== onReset || $[21] !== t7) {
    t8 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t7}</FilterDrawerShell>;
    $[17] = isDrawerOpen;
    $[18] = onApplyDrawer;
    $[19] = onCloseDrawer;
    $[20] = onReset;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp3(t0) {
  const {
    context
  } = t0;
  return (context?.queryCodes ?? []).filter(_temp).map(_temp2);
}
function _temp2(item_0) {
  return {
    value: item_0.code,
    label: item_0.value
  };
}
function _temp(item) {
  return Boolean(item.code && item.value);
}